import { Award, Clock3, MapPin, Sparkles } from 'lucide-react'
import { heroContent, trustStrip, type TrustItem } from '../../data/homepage'
import { ButtonLink } from '../ui/button'

export interface HeroSectionProps {}

const trustIcons: Record<TrustItem['icon'], typeof Clock3> = {
  history: Clock3,
  award: Award,
  location: MapPin,
  sparkle: Sparkles,
}

export function HeroSection(_: Readonly<HeroSectionProps>) {
  return (
    <>
      <section className="hero-section" aria-labelledby="home-heading">
        <img
          className="hero-image"
          src={heroContent.image}
          alt="A black luxury vehicle in a dark professional detailing studio."
          width="1376"
          height="768"
          fetchPriority="high"
        />
        <div className="hero-overlay" />
        <div className="section-container hero-content">
          <div className="hero-copy">
            <h1 id="home-heading">
              {heroContent.titlePrefix}
              <br />
              <span>{heroContent.titleHighlight}</span>
              {heroContent.titleSuffix ? ` ${heroContent.titleSuffix}` : null}
            </h1>
            {heroContent.copy.map((paragraph) => (
              <p key={paragraph}>{paragraph}</p>
            ))}
            <div className="hero-actions">
              <ButtonLink href={heroContent.ctaHref}>{heroContent.cta}</ButtonLink>
              <ButtonLink href={heroContent.secondaryCtaHref} variant="ghost">
                {heroContent.secondaryCta}
              </ButtonLink>
            </div>
          </div>
        </div>
      </section>

      <section className="trust-strip" aria-label="Autoglow studio credentials">
        <div className="section-container trust-grid">
          {trustStrip.map((item) => {
            const Icon = trustIcons[item.icon]
            return (
              <article key={item.title}>
                <Icon size={32} aria-hidden="true" />
                <div>
                  <p className="trust-title">{item.title}</p>
                  <p>{item.copy}</p>
                </div>
              </article>
            )
          })}
        </div>
      </section>
    </>
  )
}
